import { render } from "./NewsTagging.vue?vue&type=template&id=a22a1816&scoped=true"
import script from "./NewsTagging.vue?vue&type=script&lang=js"
export * from "./NewsTagging.vue?vue&type=script&lang=js"

import "./NewsTagging.vue?vue&type=style&index=0&id=a22a1816&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22a1816"]])

export default __exports__